export default __webpack_public_path__ + "static/glass_pack-87c4cc4a68a296c40f999f6a5bb306e3.png";